module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.filters,
      "fields": _vm.fields,
      "hideButtons": true
    },
    on: {
      "change": _vm.filtersChanged
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1164d42d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/EventStatisticsConfig.vue
// module id = 970
// module chunks = 2